import React from 'react'
import { OfficeContext } from './OfficeProvider'

function useOfficeState() {
    return React.useContext(OfficeContext)
}

export default useOfficeState
